module.exports = __webpack_public_path__ + "img/rho-17-werkstatt.fc5ca683.jpeg";